/**
 * Tooltip copy for inventory / rate grid cells when stop sell or restrictions apply.
 */

export function getInventoryCellTooltip({ inventory, availableRooms } = {}) {
  if (!inventory) return '';

  const reason = String(inventory.reason || '').trim();
  const withReason = (label) => (reason ? `${label}\n${reason}` : label);

  // Restriction / blocked (available === false) takes priority
  if (inventory.available === false) {
    return withReason('Restriction applied');
  }

  // Explicit stop sell flag
  if (inventory.sold_out === true) {
    return withReason('Stop sell applied');
  }

  // Natural zero availability
  if (availableRooms === 0 || availableRooms === '0') {
    return 'Sold out — no rooms available';
  }

  return '';
}

export function getRateCellTooltip(rate) {
  if (!rate) return '';

  const parts = [];
  if (rate.stop_sell || rate.stopSell) {
    parts.push('Stop sell applied');
    parts.push('Click to manage stop sell');
  }
  if (rate.available === false) {
    parts.push('Rate blocked / restriction applied');
    if (!(rate.stop_sell || rate.stopSell)) {
      parts.push('Click to manage stop sell');
    }
  }
  if (rate.min_los != null && rate.min_los !== '' && Number(rate.min_los) > 1) {
    parts.push(`Min stay: ${rate.min_los} night(s)`);
  }
  if (rate.max_los != null && rate.max_los !== '' && Number(rate.max_los) > 0) {
    parts.push(`Max stay: ${rate.max_los} night(s)`);
  }

  return parts.join('\n');
}
